/* 🤖 this file was generated by svg-to-ts */

import { EmperorIcon } from './emperor-icons/emperor-icons';

export type EmperorIconNameSubset<
  T extends Readonly<EmperorIcon[]>
> = T[number]['name'];

export * from './emperor-icons/emperorIcon-account_circle.icon';
export * from './emperor-icons/emperorIcon-add_1.icon';
export * from './emperor-icons/emperorIcon-add_circle_2.icon';
export * from './emperor-icons/emperorIcon-arrange_1_to_9.icon';
export * from './emperor-icons/emperorIcon-arrange_9_to_1.icon';
export * from './emperor-icons/emperorIcon-arrange_a_to_z.icon';
export * from './emperor-icons/emperorIcon-arrange_z_to_a.icon';
export * from './emperor-icons/emperorIcon-arrow_back.icon';
export * from './emperor-icons/emperorIcon-arrow_down_right.icon';
export * from './emperor-icons/emperorIcon-arrow_drop_down.icon';
export * from './emperor-icons/emperorIcon-arrow_forward.icon';
export * from './emperor-icons/emperorIcon-arrow_up_right.icon';
export * from './emperor-icons/emperorIcon-banking-bank-account.icon';
export * from './emperor-icons/emperorIcon-bin.icon';
export * from './emperor-icons/emperorIcon-bold_penguin.icon';
export * from './emperor-icons/emperorIcon-bond.icon';
export * from './emperor-icons/emperorIcon-box_2.icon';
export * from './emperor-icons/emperorIcon-briefcase.icon';
export * from './emperor-icons/emperorIcon-bug_report.icon';
export * from './emperor-icons/emperorIcon-building_5.icon';
export * from './emperor-icons/emperorIcon-calendar_1.icon';
export * from './emperor-icons/emperorIcon-calendar_shield.icon';
export * from './emperor-icons/emperorIcon-carrier_appointments.icon';
export * from './emperor-icons/emperorIcon-chat_bubble_square_question_mark.icon';
export * from './emperor-icons/emperorIcon-check_box.icon';
export * from './emperor-icons/emperorIcon-check_circle_2_1.icon';
export * from './emperor-icons/emperorIcon-check_circle_2_2.icon';
export * from './emperor-icons/emperorIcon-check_circle_2.icon';
export * from './emperor-icons/emperorIcon-check_in_circle.icon';
export * from './emperor-icons/emperorIcon-check.icon';
export * from './emperor-icons/emperorIcon-clock_outline.icon';
export * from './emperor-icons/emperorIcon-clock.icon';
export * from './emperor-icons/emperorIcon-close_1.icon';
export * from './emperor-icons/emperorIcon-close.icon';
export * from './emperor-icons/emperorIcon-cog_double.icon';
export * from './emperor-icons/emperorIcon-commercial_property.icon';
export * from './emperor-icons/emperorIcon-commissions.icon';
export * from './emperor-icons/emperorIcon-contact_book_1.icon';
export * from './emperor-icons/emperorIcon-coverage_aviation.icon';
export * from './emperor-icons/emperorIcon-coverage_boiler_machinery.icon';
export * from './emperor-icons/emperorIcon-coverage_bond.icon';
export * from './emperor-icons/emperorIcon-coverage_builders_risk.icon';
export * from './emperor-icons/emperorIcon-coverage_business_owners_policy.icon';
export * from './emperor-icons/emperorIcon-coverage_commercial_auto.icon';
export * from './emperor-icons/emperorIcon-coverage_commercial_flood.icon';
export * from './emperor-icons/emperorIcon-coverage_commercial_property.icon';
export * from './emperor-icons/emperorIcon-coverage_crime.icon';
export * from './emperor-icons/emperorIcon-coverage_cyber_liability.icon';
export * from './emperor-icons/emperorIcon-coverage_difference_in_conditions.icon';
export * from './emperor-icons/emperorIcon-coverage_directors_officers.icon';
export * from './emperor-icons/emperorIcon-coverage_employment_practice_liability.icon';
export * from './emperor-icons/emperorIcon-coverage_garage_dealers.icon';
export * from './emperor-icons/emperorIcon-coverage_general_liability.icon';
export * from './emperor-icons/emperorIcon-coverage_inland_marine.icon';
export * from './emperor-icons/emperorIcon-coverage_liquor_liability.icon';
export * from './emperor-icons/emperorIcon-coverage_other.icon';
export * from './emperor-icons/emperorIcon-coverage_owners_contractors_protective_liability.icon';
export * from './emperor-icons/emperorIcon-coverage_pollution_liability.icon';
export * from './emperor-icons/emperorIcon-coverage_professional_liability.icon';
export * from './emperor-icons/emperorIcon-coverage_special_events.icon';
export * from './emperor-icons/emperorIcon-coverage_umbrella.icon';
export * from './emperor-icons/emperorIcon-coverage_watercraft.icon';
export * from './emperor-icons/emperorIcon-coverage_workers_compensation.icon';
export * from './emperor-icons/emperorIcon-coverage-farm.icon';
export * from './emperor-icons/emperorIcon-crime.icon';
export * from './emperor-icons/emperorIcon-dat_transfer_8.icon';
export * from './emperor-icons/emperorIcon-data_download_9.icon';
export * from './emperor-icons/emperorIcon-data_transfer_8_1.icon';
export * from './emperor-icons/emperorIcon-data_upload_1.icon';
export * from './emperor-icons/emperorIcon-delete.icon';
export * from './emperor-icons/emperorIcon-directors_officers.icon';
export * from './emperor-icons/emperorIcon-dollar_circle.icon';
export * from './emperor-icons/emperorIcon-email.icon';
export * from './emperor-icons/emperorIcon-employment_practice.icon';
export * from './emperor-icons/emperorIcon-fees.icon';
export * from './emperor-icons/emperorIcon-file_add_2.icon';
export * from './emperor-icons/emperorIcon-file_alert_1.icon';
export * from './emperor-icons/emperorIcon-file_check_1.icon';
export * from './emperor-icons/emperorIcon-file_close_1.icon';
export * from './emperor-icons/emperorIcon-file_copy.icon';
export * from './emperor-icons/emperorIcon-file_download_1.icon';
export * from './emperor-icons/emperorIcon-file_office_pdf.icon';
export * from './emperor-icons/emperorIcon-file_shield.icon';
export * from './emperor-icons/emperorIcon-file_statistic_new_1.icon';
export * from './emperor-icons/emperorIcon-file_timeout.icon';
export * from './emperor-icons/emperorIcon-file_view_2.icon';
export * from './emperor-icons/emperorIcon-file.icon';
export * from './emperor-icons/emperorIcon-flood.icon';
export * from './emperor-icons/emperorIcon-hash.icon';
export * from './emperor-icons/emperorIcon-hide.icon';
export * from './emperor-icons/emperorIcon-house.icon';
export * from './emperor-icons/emperorIcon-inbox.icon';
export * from './emperor-icons/emperorIcon-interface_alert_circle_1.icon';
export * from './emperor-icons/emperorIcon-interface_alert_circle.icon';
export * from './emperor-icons/emperorIcon-interface_alert_triangle_1.icon';
export * from './emperor-icons/emperorIcon-interface_alert_triangle.icon';
export * from './emperor-icons/emperorIcon-interface_information_1.icon';
export * from './emperor-icons/emperorIcon-interface_information.icon';
export * from './emperor-icons/emperorIcon-interface_question_mark.icon';
export * from './emperor-icons/emperorIcon-keyboard_arrow_down.icon';
export * from './emperor-icons/emperorIcon-keyboard_arrow_left.icon';
export * from './emperor-icons/emperorIcon-keyboard_arrow_right.icon';
export * from './emperor-icons/emperorIcon-keyboard_arrow_up.icon';
export * from './emperor-icons/emperorIcon-laptop_shield.icon';
export * from './emperor-icons/emperorIcon-launch.icon';
export * from './emperor-icons/emperorIcon-lightbulb.icon';
export * from './emperor-icons/emperorIcon-list-bullets.icon';
export * from './emperor-icons/emperorIcon-location_pin_2.icon';
export * from './emperor-icons/emperorIcon-lock_1_1.icon';
export * from './emperor-icons/emperorIcon-lock_1.icon';
export * from './emperor-icons/emperorIcon-login_2.icon';
export * from './emperor-icons/emperorIcon-logout_2.icon';
export * from './emperor-icons/emperorIcon-megaphone.icon';
export * from './emperor-icons/emperorIcon-menu-open-round.icon';
export * from './emperor-icons/emperorIcon-miscellaneous_professional.icon';
export * from './emperor-icons/emperorIcon-money.icon';
export * from './emperor-icons/emperorIcon-navigation_before_1_1.icon';
export * from './emperor-icons/emperorIcon-navigation_before_1.icon';
export * from './emperor-icons/emperorIcon-navigation_drawer_2.icon';
export * from './emperor-icons/emperorIcon-navigation_next_1_1.icon';
export * from './emperor-icons/emperorIcon-navigation_next_1.icon';
export * from './emperor-icons/emperorIcon-navigation_right_1.icon';
export * from './emperor-icons/emperorIcon-navigation_show_more_horizontal.icon';
export * from './emperor-icons/emperorIcon-navigation_show_more_vertical.icon';
export * from './emperor-icons/emperorIcon-network_download.icon';
export * from './emperor-icons/emperorIcon-operator_male.icon';
export * from './emperor-icons/emperorIcon-organization-hierarchy-2.icon';
export * from './emperor-icons/emperorIcon-page_not_found.icon';
export * from './emperor-icons/emperorIcon-page.icon';
export * from './emperor-icons/emperorIcon-paw.icon';
export * from './emperor-icons/emperorIcon-pencil_3_1.icon';
export * from './emperor-icons/emperorIcon-pencil_circle.icon';
export * from './emperor-icons/emperorIcon-pending.icon';
export * from './emperor-icons/emperorIcon-percent_circle.icon';
export * from './emperor-icons/emperorIcon-percent.icon';
export * from './emperor-icons/emperorIcon-phone.icon';
export * from './emperor-icons/emperorIcon-prefill_lightning.icon';
export * from './emperor-icons/emperorIcon-printer.icon';
export * from './emperor-icons/emperorIcon-receipt_3.icon';
export * from './emperor-icons/emperorIcon-redo.icon';
export * from './emperor-icons/emperorIcon-remove_circle_2_1.icon';
export * from './emperor-icons/emperorIcon-remove_circle_2.icon';
export * from './emperor-icons/emperorIcon-search_1.icon';
export * from './emperor-icons/emperorIcon-search.icon';
export * from './emperor-icons/emperorIcon-server_error.icon';
export * from './emperor-icons/emperorIcon-share.icon';
export * from './emperor-icons/emperorIcon-shield_cash.icon';
export * from './emperor-icons/emperorIcon-shield_check.icon';
export * from './emperor-icons/emperorIcon-shield_settings.icon';
export * from './emperor-icons/emperorIcon-shield.icon';
export * from './emperor-icons/emperorIcon-shopping_cart_1.icon';
export * from './emperor-icons/emperorIcon-sign_dollar_smooth.icon';
export * from './emperor-icons/emperorIcon-sign_dollar.icon';
export * from './emperor-icons/emperorIcon-star_circle.icon';
export * from './emperor-icons/emperorIcon-store.icon';
export * from './emperor-icons/emperorIcon-subtract_circle_2_1.icon';
export * from './emperor-icons/emperorIcon-subtract_circle_2.icon';
export * from './emperor-icons/emperorIcon-taxes.icon';
export * from './emperor-icons/emperorIcon-time_circle.icon';
export * from './emperor-icons/emperorIcon-truck.icon';
export * from './emperor-icons/emperorIcon-umbrella.icon';
export * from './emperor-icons/emperorIcon-user upload.icon';
export * from './emperor-icons/emperorIcon-user_chat_1.icon';
export * from './emperor-icons/emperorIcon-user_chat_2.icon';
export * from './emperor-icons/emperorIcon-user_group.icon';
export * from './emperor-icons/emperorIcon-user_share_1.icon';
export * from './emperor-icons/emperorIcon-user_shield 1.icon';
export * from './emperor-icons/emperorIcon-user_shield.icon';
export * from './emperor-icons/emperorIcon-user.icon';
export * from './emperor-icons/emperorIcon-video_control_play.icon';
export * from './emperor-icons/emperorIcon-view_lock.icon';
export * from './emperor-icons/emperorIcon-vote_star_1.icon';
export * from './emperor-icons/emperorIcon-vote_star.icon';
export * from './emperor-icons/emperorIcon-webhook.icon';
export * from './emperor-icons/emperorIcon-worker.icon';
export * from './emperor-icons/emperorIcon-write_modify_tool_edit_pen.icon';
export * from './emperor-icons/emperor-icons';
